<template>
  <div class="mb-2">
    <b-row>
      <b-col>
        <div class="default-filter-buttons m-0 justify-content-end">
          <b-button
            id="default-filter-new-btn"
            variant="primary"
            type="button"
            class="default-filter-new-btn m-0"
            @click="createWebhook"
          >
            <feather-icon icon="PlusIcon" size="15" />
            <b-tooltip
              triggers="hover"
              target="default-filter-new-btn"
              :title="t('Create Webhook')"
              :delay="{ show: 0, hide: 50 }"
            />
          </b-button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { BButton, BTooltip, BRow, BCol } from 'bootstrap-vue';
import { useUtils as useI18nUtils } from '@core/libs/i18n';
import { helper } from '@core/mixins/helper.js';

export default {
  components: {
    BButton,
    BTooltip,
    BRow,
    BCol
  },
  mixins: [helper],
  props: {
    values: {
      type: Object,
      required: true
    },
    filterSubmitting: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  watch: {},
  methods: {
    filter() {
      this.$emit('filter', this.getFilteredObject(this.values) || {});
    },
    createWebhook() {
      this.$router.push('/web-hooks/create');
    }
  },
  setup() {
    const { t } = useI18nUtils();

    return {
      t
    };
  }
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
